<template>
  <div class="no-results-suggestions">
    <div class="h3 my-4 pb-4">Ci dispiace! Non ci sono risultati</div>

    <!-- SUGGESTIONS BY RADIUS -->
    <div
      class="panel"
      v-if="
        suggested_by_radius.departure.length ||
        suggested_by_radius.arrival.length ||
        suggested_by_radius.departure_arrival.length
      "
    >
      <h6 class="no-results-suggestions--heading">
        Vuoi volare da un aeroporto vicino? Scopri queste offerte.
      </h6>
      <div class="no-results-suggestions--flights">
        <b-row>
          <b-col md="6" class="m-auto" v-if="suggested_by_radius.departure.length">
            <div class="no-results-suggestions--title">Parti da:</div>
            <div
              class="no-results-suggestions--flight"
              v-for="(suggestion, index) in suggested_by_radius.departure"
              v-bind:key="'or_dep_' + index + _uid"
            >
              <div class="no-results-suggestions--flight--left">
                <div class="text-tertiary bold">
                  {{
                    suggestions_by_radius.dictionaries.locations[suggestion.iata_code_departure]
                      .name
                  }}
                  ({{ suggestion.iata_code_departure }})
                </div>
                <div>
                  A partire da
                  <span class="text-primary bold"
                    >{{ apply_markup_to_number(suggestion.flight_offer, suggestion.min_price) }}
                    {{ suggestions_by_radius.dictionaries.currencies[suggestion.currency] }}</span
                  >
                </div>
              </div>
              <div class="no-results-suggestions--flight--right">
                <b-button
                  size="md"
                  variant="tertiary"
                  @click="
                    search_by_suggestion({ iata_code_departure: suggestion.iata_code_departure })
                  "
                >
                  Scopri!
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col md="6" class="m-auto" v-if="suggested_by_radius.arrival.length">
            <div class="no-results-suggestions--title">Arriva a:</div>
            <div
              class="no-results-suggestions--flight"
              v-for="(suggestion, index) in suggested_by_radius.arrival"
              v-bind:key="'or_arr_' + index + _uid"
            >
              <div class="no-results-suggestions--flight--left">
                <div class="text-tertiary bold">
                  {{
                    suggestions_by_radius.dictionaries.locations[suggestion.iata_code_arrival].name
                  }}
                  ({{ suggestion.iata_code_arrival }})
                </div>
                <div class="no-results-suggestions--price">
                  A partire da
                  <span
                    >{{ suggestion.min_price }}
                    {{ suggestions_by_radius.dictionaries.currencies[suggestion.currency] }}</span
                  >
                </div>
              </div>
              <div class="no-results-suggestions--flight--right">
                <b-button
                  size="md"
                  variant="tertiary"
                  @click="search_by_suggestion({ iata_code_arrival: suggestion.iata_code_arrival })"
                >
                  Scopri!
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>

        <div v-if="suggested_by_radius.departure_arrival.length">
          <!-- il copy "oppure" ha senso solo se sopra ci sono altre offerte -->
          <div
            v-if="
              suggested_by_radius.departure.length > 0 || suggested_by_radius.arrival.length > 0
            "
            class="no-results-suggestions--title"
          >
            Oppure:
          </div>

          <b-row>
            <b-col
              md="6"
              v-for="(suggestion, index) in suggested_by_radius.departure_arrival"
              v-bind:key="'or_arr_' + index + _uid"
            >
              <div class="no-results-suggestions--flight">
                <div class="no-results-suggestions--flight--left">
                  <div class="text-tertiary">
                    <div>
                      Parti da:
                      <span class="bold"
                        >{{
                          suggestions_by_radius.dictionaries.locations[
                            suggestion.iata_code_departure
                          ].name
                        }}
                        ({{ suggestion.iata_code_departure }})</span
                      >
                    </div>
                    <div>
                      Arriva a:
                      <span class="bold"
                        >{{
                          suggestions_by_radius.dictionaries.locations[suggestion.iata_code_arrival]
                            .name
                        }}
                        ({{ suggestion.iata_code_arrival }})</span
                      >
                    </div>
                  </div>
                  <div class="no-results-suggestions--price">
                    A partire da
                    <span
                      >{{ suggestion.min_price }}
                      {{ suggestions_by_radius.dictionaries.currencies[suggestion.currency] }}</span
                    >
                  </div>
                </div>
                <div class="no-results-suggestions--flight--right">
                  <b-button
                    size="md"
                    variant="tertiary"
                    @click="
                      search_by_suggestion({
                        iata_code_arrival: suggestion.iata_code_arrival,
                        iata_code_departure: suggestion.iata_code_departure,
                      })
                    "
                  >
                    Scopri!
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- SUGGESTIONS BY TIME WINDOW / LIST -->
    <div class="panel" v-if="suggested_by_time_window.suggested.length">
      <h6 class="no-results-suggestions--heading">Valuta altre date!</h6>
      <div class="no-results-suggestions--flights">
        <b-row>
          <b-col
            md="6"
            v-for="(suggestion, index) in suggested_by_time_window.suggested"
            v-bind:key="'tf_dep_' + index + _uid"
          >
            <div class="no-results-suggestions--flight">
              <div class="no-results-suggestions--flight--left">
                <div class="text-tertiary bold">
                  {{ parse_flight_offers_date(suggestion.in).friendly_date_short | lowercase }}
                  <span v-if="return_flight">
                    -
                    {{
                      parse_flight_offers_date(suggestion.out).friendly_date_short | lowercase
                    }}</span
                  >
                </div>
                <div class="no-results-suggestions--price">
                  A partire da
                  <span
                    >{{ apply_markup_to_number(suggestion.flight_offer, suggestion.min_price) }}
                    {{
                      suggestions_by_time_window.dictionaries.currencies[suggestion.currency]
                    }}</span
                  >
                </div>
              </div>
              <div class="no-results-suggestions--flight--right">
                <b-button
                  size="md"
                  variant="tertiary"
                  @click="search_by_suggestion({ in: suggestion.in, out: suggestion.out })"
                >
                  Scopri!
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { get_flight_offer_dates, apply_markup_to_number } from '@/flight-offer';
import { parse_flight_offers_date, parse_flight_offers_carriers } from '@/utilities';

export default {
  name: 'no-results-suggestions',
  components: {},
  props: {},
  computed: {
    suggestions: {
      get() {
        return this.$store.state.liveflight.suggestions;
      },
      set() {},
    },
    suggestions_by_radius: {
      get() {
        if (Object.keys(this.suggestions) == 0) return { flights: [] };
        if (Object.keys(this.suggestions.by_radius) == 0) return { flights: [] };
        if (this.suggestions.by_radius.flights == undefined) return { flights: [] };
        return this.suggestions.by_radius;
      },
      set() {},
    },
    suggestions_by_time_window: {
      get() {
        if (Object.keys(this.suggestions) == 0) return { flights: [] };
        if (Object.keys(this.suggestions.by_time_window) == 0) return { flights: [] };
        if (this.suggestions.by_time_window.flights == undefined) return { flights: [] };
        return this.suggestions.by_time_window;
      },
      set() {},
    },
    return_flight: {
      get() {
        return this.$store.state.liveflight.return_flight;
      },
      set(value) {
        this.$store.commit('return_flight', value);
      },
    },
    departure_airport: {
      get() {
        return this.$store.state.liveflight.departure_airport;
      },
      set(value) {
        this.$store.commit('departure_airport', value);
      },
    },
    departure_airport_label: {
      get() {
        return this.$store.state.liveflight.departure_airport_label;
      },
      set(value) {
        this.$store.commit('departure_airport_label', value);
      },
    },
    arrival_airport: {
      get() {
        return this.$store.state.liveflight.arrival_airport;
      },
      set(value) {
        this.$store.commit('arrival_airport', value);
      },
    },
    arrival_airport_label: {
      get() {
        return this.$store.state.liveflight.arrival_airport_label;
      },
      set(value) {
        this.$store.commit('arrival_airport_label', value);
      },
    },
    departure_date: {
      get() {
        return this.$store.state.liveflight.departure_date;
      },
      set(value) {
        this.$store.commit('departure_date', value);
      },
    },
    return_date: {
      get() {
        return this.$store.state.liveflight.return_date;
      },
      set(value) {
        this.$store.commit('return_date', value);
      },
    },
  },
  data() {
    return {
      loading: true,
      dates_in: [],
      dates_out: [],
      grid_items: [],
      suggested_by_time_window: {
        suggested: [],
      },
      suggested_by_radius: {
        departure: [],
        arrival: [],
        departure_arrival: [],
      },
    };
  },
  created() {
    this.get_flight_offer_dates = get_flight_offer_dates;
    this.parse_flight_offers_date = parse_flight_offers_date;
    this.apply_markup_to_number = apply_markup_to_number;
    this.parse_flight_offers_carriers = parse_flight_offers_carriers;
  },
  mounted() {
    this.get_suggested_by_time_window_airports();
    this.get_suggested_by_radius_airports();
  },
  methods: {
    get_suggested_by_time_window_airports() {
      let suggested_flight_offers = [],
        _this = this;

      this.suggestions_by_time_window.flights.forEach((f) => {
        let date_in = this.get_flight_offer_dates(f).departure.at,
          date_out = this.return_flight ? this.get_flight_offer_dates(f).return.at : '',
          dates = date_in + '-' + date_out;

        if (
          suggested_flight_offers.filter(function (s) {
            return s.in + '-' + s.out == dates;
          }).length == 0
        ) {
          // trovo il prezzo minore per quella coppia di date
          let min_price = this.suggestions_by_time_window.flights
            .filter(function (s) {
              return (
                _this.get_flight_offer_dates(s).departure.at +
                  '-' +
                  (_this.return_flight ? _this.get_flight_offer_dates(s).return.at : '') ==
                dates
              );
            })
            .sort((a, b) => a.price.grandTotal - b.price.grandTotal)[0];

          suggested_flight_offers.push({
            in: date_in,
            out: date_out,
            min_price: min_price.price.grandTotal,
            currency: min_price.price.currency,
            flight_offer: f,
          });
        }
      });

      suggested_flight_offers.sort((a, b) => new Date(a.in) - new Date(b.in));

      this.suggested_by_time_window = {
        suggested: suggested_flight_offers,
      };
    },
    get_suggested_by_radius_airports() {
      let departure = [],
        arrival = [],
        departure_arrival = [],
        _this = this;

      this.suggestions_by_radius.flights.forEach((f) => {
        let iata_code_departure = _this.get_flight_offer_dates(f).departure.iataCode,
          iata_code_arrival =
            f.itineraries[0].segments[f.itineraries[0].segments.length - 1].arrival.iataCode;

        // aeroporti con partenza diversa da quella della ricerca ma stesso arrivo
        if (
          iata_code_departure !== _this.departure_airport &&
          iata_code_arrival == _this.arrival_airport
        ) {
          if (
            departure.filter(function (s) {
              return s.iata_code_departure == iata_code_departure;
            }).length == 0
          ) {
            // calcolo il prezzo minore per offerte suggerite che abbiano questo aeroporto di partenza
            let min_price = this.suggestions_by_radius.flights
              .filter(function (s) {
                return _this.get_flight_offer_dates(s).departure.iataCode == iata_code_departure;
              })
              .sort((a, b) => a.price.grandTotal - b.price.grandTotal)[0];

            // tiro fuori tre chiavi per comodità, ma metto anche la flight_offer intera per gestire il click del pulsante
            departure.push({
              iata_code_departure: iata_code_departure,
              min_price: min_price.price.grandTotal,
              currency: min_price.price.currency,
              flight_offer: f,
            });
          }
        }

        // aeroporti con stessa partenza di quella della ricerca ma con arrivo diverso
        if (
          iata_code_departure == _this.departure_airport &&
          iata_code_arrival !== _this.arrival_airport
        ) {
          if (
            arrival.filter(function (s) {
              return s.iata_code_arrival == iata_code_arrival;
            }).length == 0
          ) {
            let min_price = this.suggestions_by_radius.flights
              .filter(function (s) {
                return (
                  s.itineraries[0].segments[s.itineraries[0].segments.length - 1].arrival
                    .iataCode == iata_code_arrival
                );
              })
              .sort((a, b) => a.price.grandTotal - b.price.grandTotal)[0];

            arrival.push({
              // tiro fuori tre chiavi per comodità, ma metto anche la flight_offer intera per gestire il click del pulsante
              iata_code_arrival: iata_code_arrival,
              min_price: min_price.price.grandTotal,
              currency: min_price.price.currency,
              flight_offer: f,
            });
          }
        }

        // aeroporti con diversa partenza e diverso arrivo rispetto a quelli della ricerca
        if (
          iata_code_departure !== _this.departure_airport &&
          iata_code_arrival !== _this.arrival_airport
        ) {
          if (
            departure_arrival.filter(function (s) {
              return (
                s.iata_code_departure == iata_code_departure &&
                s.iata_code_arrival == iata_code_arrival
              );
            }).length == 0
          ) {
            // calcolo il prezzo minore per offerte suggerite che abbiano questo aeroporto di partenza
            let min_price = this.suggestions_by_radius.flights
              .filter(function (s) {
                return (
                  _this.get_flight_offer_dates(s).departure.iataCode == iata_code_departure &&
                  s.itineraries[0].segments[s.itineraries[0].segments.length - 1].arrival
                    .iataCode == iata_code_arrival
                );
              })
              .sort((a, b) => a.price.grandTotal - b.price.grandTotal)[0];

            // tiro fuori tre chiavi per comodità, ma metto anche la flight_offer intera per gestire il click del pulsante
            departure_arrival.push({
              iata_code_departure: iata_code_departure,
              iata_code_arrival: iata_code_arrival,
              min_price: min_price.price.grandTotal,
              currency: min_price.price.currency,
              flight_offer: f,
            });
          }
        }
      });

      this.suggested_by_radius = {
        departure: departure,
        arrival: arrival,
        departure_arrival: departure_arrival,
      };
    },
    search_by_suggestion(suggestion) {
      if (suggestion.iata_code_departure) {
        this.departure_airport = suggestion.iata_code_departure;
        this.departure_airport_label =
          this.suggestions_by_radius.dictionaries.locations[suggestion.iata_code_departure].name;
      }

      if (suggestion.iata_code_arrival) {
        this.arrival_airport = suggestion.iata_code_arrival;
        this.arrival_airport_label =
          this.suggestions_by_radius.dictionaries.locations[suggestion.iata_code_arrival].name;
      }

      if (suggestion.in) {
        this.departure_date = suggestion.in.split('T')[0];
      }

      if (suggestion.out) {
        this.return_date = suggestion.out.split('T')[0];
      }

      window.eventBus.$emit('trigger-search-by-suggestion');
    },
  },
};
</script>

<style lang="scss">
.no-results-suggestions {
  text-align: center;
  margin-bottom: $grid-gutter-width;
  .panel {
    padding: $grid-gutter-width $grid-gutter-width;
    margin-bottom: $grid-gutter-width !important;
  }
  &--heading {
    @extend .h1 !optional;
    margin-bottom: $grid-gutter-width;
    font-weight: bold;
  }
  &--flights {
    & > .row > div {
      //margin:auto;
    }
  }
  &--title {
    text-align: left;
    @include font-primary-regular;
    margin-top: 16px;
    margin-bottom: 20px;
    text-transform: uppercase;
  }
  &--flight {
    width: 100%;
    display: flex;
    margin-bottom: 4px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid $light-gray;
    margin-bottom: 16px;
    padding-bottom: 16px;
    &--left {
      flex: 1;
      text-align: left;
      padding-right: 20px;
    }
    &--right {
      text-align: right;
    }
  }
  .flight-offer {
    &--carriers {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      & > * {
        margin: 2px 3px;
      }
    }
    &--carrier {
      @extend .carrier-icon !optional;
    }
  }
  &--price {
    span {
      color: $primary;
      @include font-primary-bold;
    }
  }
}
</style>
